import {
  CreditCard as CreditCardIcon,
  PaymentsRounded,
  PriceChange as PriceChangeIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  billing: PaymentsRounded,
  subscriptions: CreditCardIcon,
  logs: ReceiptIcon,
  plans: PriceChangeIcon,
};

const billing: NavItemType = {
  id: 'group-billing',
  title: 'Billing',
  type: 'group',
  icon: icons.billing,
  children: [
    {
      id: 'subscription-plans',
      title: 'Subscription Plans',
      type: 'item',
      color: 'primary',
      url: '/subscription-plans',
      icon: icons.plans,
      permissionModule: 'subscription_plans',
    },
  ],
  color: undefined,
  url: undefined
};

export default billing;
